import {ActivateUserVo} from '../../common/shared/api/nicolas/vo/ActivateUserApiResultVo.interface';
import {ActivateUser} from '../generated/types';

export function createActivateUser(
  activateUserVo: ActivateUserVo
): ActivateUser {
  return {
    requestExpireTime: activateUserVo.request_expire_time,
  };
}
